import { render } from "./BlogDetailsArea.vue?vue&type=template&id=4c9d10e7"
import script from "./BlogDetailsArea.vue?vue&type=script&lang=js"
export * from "./BlogDetailsArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__